/* 12.10: петля «ритуал» играет только на экране; reduced-motion -> постер без автоплея. */
(function () {
  if (window.__pdRitualVideo) return;
  window.__pdRitualVideo = true;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var io = null, ioLoad = null;
  var seen = [];
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function ensure(v) {
    if (v.getAttribute('data-pd-loaded')) return;
    v.setAttribute('data-pd-loaded', '1');
    v.preload = 'auto';
    v.load();
    if (ioLoad) ioLoad.unobserve(v);
  }
  function onHit(entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && !mq.matches) { ensure(v); play(v); } else v.pause();
    });
  }
  function onNear(entries) {
    entries.forEach(function (e) { if (e.isIntersecting && !mq.matches) ensure(e.target); });
  }
  function bind(v) {
    if (seen.indexOf(v) !== -1) return;
    seen.push(v);
    v.removeAttribute('autoplay');
    if (mq.matches) { v.pause(); }
    if (ioLoad) ioLoad.observe(v);
    if (io) io.observe(v); else if (!mq.matches) { ensure(v); play(v); }
  }
  function scan() { document.querySelectorAll('video[data-pd-loop]').forEach(bind); }
  function start() {
    if ('IntersectionObserver' in window) { io = new IntersectionObserver(onHit, { threshold: 0.5 }); ioLoad = new IntersectionObserver(onNear, { rootMargin: '200px 0px' }); }
    scan();
    if (window.MutationObserver) new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    var chg = function () { seen.forEach(function (v) { if (mq.matches) v.pause(); }); };
    if (mq.addEventListener) mq.addEventListener('change', chg); else if (mq.addListener) mq.addListener(chg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
